export default __webpack_public_path__ + "static/media/Group9254.77171729.svg";